import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Colors from "../../../../../utils/Colors";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridRow: {
      display: "flex",
      width: "100%",
    },
    container: {
      width: "100%",
      backgroundColor: Colors.WHITE,
      padding: 10,
    },
    contentContainer: {
      height: "100%",
      overflow: "auto",
      border: "1px solid " + Colors.SILVER_SAND,
      borderRadius: 5,
      padding: theme.spacing(1),
    },
    cardHeader: {
      padding: theme.spacing(1, 2),
    },
    input: {
      marginRight: theme.spacing(1),
    },
    demo: {
      backgroundColor: theme.palette.background.paper,
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    paper: {
      backgroundColor: Colors.WHITE,
      borderRadius: 5,
      borderColor: Colors.SILVER_SAND,
      width: "50%",
      height: "50%",
      padding: 10,
      overflow: "auto",
      overflowX: "hidden",
    },
    dividerContainer: {
      margin: 20,
    },
    placeholderText: {
      textAlign: "center",
      color: Colors.SILVER_SAND,
    },
    buttons: {
      display: "flex",
      justifyContent: "flex-end",
      marginRight: theme.spacing(4),
    },
    button: {
      marginTop: theme.spacing(3),
      marginLeft: theme.spacing(1),
    },
    arrowButton: {
      padding: theme.spacing(1),
    },
  })
);

export default useStyles;
